
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';

import styles from 'assets/jss/fields/formik-field-style.js';
import { digitsEnToFa, digitsFaToEn } from 'persian-tools2';

const useStyles = makeStyles(styles);

const CustomTextField = ({
  name,
  label,
  errors,
  values,
  type,
  icon,
  setFieldValue,
  maxLength,
  disabled,
  submitCount,
  showValueCenter,
  placeholder
}) => {
  const classes = useStyles();

  const isNumeric = ['number', 'tel'].includes(type);
  const fieldValue = values[name] ?? '';

  const inputWidth = isNumeric
    ? '100%'
    : `${String(fieldValue).length + 1.5}ch`;

  const inputProps = {
    style: {
      textAlign: showValueCenter ? 'center' : 'left',
      letterSpacing: isNumeric ? '1px' : 'normal',
      width: inputWidth,
      marginRight: 'auto'
    },
    maxLength,
    inputMode: isNumeric ? 'numeric' : 'text'
  };

  const inlineStyle = {
    '& .MuiOutlinedInput-root': {
      border:
        errors[name] && !!submitCount
          ? '1px solid var(--red) !important'
          : 'none'
    },
    input: {
      '&::placeholder': {
        opacity: '1',
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: 'normal',
        color: '#707070'
      }
    }
  };

  const onChangeHandler = (e) => {
    const value = e.target.value;

    if (isNumeric) {
      const englishValue = digitsFaToEn(value);

      if (!/^\d*$/.test(englishValue)) return;

      if (englishValue.length <= (maxLength || 11)) {
        setFieldValue(name, englishValue);
      }

      return;
    }

    setFieldValue(name, value);
  };

  return (
    <>
      <div className={classes.parentTextField}>
        <div className={classes.textFieldMarker}>
          {label ? `${label} :` : icon}
        </div>

        <TextField
          fullWidth
          type="text"
          placeholder={placeholder}
          disabled={disabled}
          name={name}
          sx={inlineStyle}
          inputProps={inputProps}
          onChange={onChangeHandler}
          className={classes.textfied}
          value={
            isNumeric
              ? digitsEnToFa(String(fieldValue))
              : fieldValue
          }
          dir={isNumeric ? 'ltr' : 'rtl'}
        />
      </div>

      {errors[name] && !!submitCount && (
        <div className={classes.errorText}>{errors[name]}</div>
      )}
    </>
  );
};

export default CustomTextField;
